/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MigracaoContratoAliases {
  ACTION_CANCELAR = 'action-cancelar',
  ATTACHMENTS_LIST = 'attachments-list',
  AUTOCOMPLETE_NOVO_CONTRATO = 'autocomplete-novo-contrato',
  AUTOCOMPLETE_PAGADOR = 'autocomplete-pagador',
  AUTOCOMPLETE_PRODUTO = 'autocomplete-produto',
  AUTOCOMPLETE_TABELA_PRECO = 'autocomplete-tabela-preco',
  CARD_0 = 'card-0',
  CONTEXTUAL_BAR_MIGRACAO_BENEF = 'contextual-bar-migracao-benef',
  DATE_FIELD_LIMITE = 'date-field-limite',
  DATE_FIELD_MIGRACAO = 'date-field-migracao',
  FETCH_FORM = 'fetch-form',
  FETCH_LISTA_ANEXOS = 'fetch-lista-anexos',
  FETCH_NOVO_CONTRATO = 'fetch-novo-contrato',
  FETCH_PAGADOR = 'fetch-pagador',
  FETCH_PRODUTO = 'fetch-produto',
  FETCH_TABELA_PRECO = 'fetch-tabela-preco',
  FIELD_ANEXOS = 'field-anexos',
  FIELD_DATA_LIMITE = 'field-data-limite',
  FIELD_DATA_MIGRACAO = 'field-data-migracao',
  FIELD_FILE_UPLOADER = 'field-fileUploader',
  FIELD_NOVO_CONTRATO = 'field-novo-contrato',
  FIELD_PAGADOR = 'field-pagador',
  FIELD_PRODUTO = 'field-produto',
  FIELD_TABELA_PRECO = 'field-tabela-preco',
  FIELD_TOAST = 'field-toast',
  FILE_UPLOADER = 'file-uploader',
  FORM_DADOS = 'form-dados',
  LOADER_0 = 'loader-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  MAPPER_NOVO_CONTRATO = 'mapper-novo-contrato',
  MAPPER_PAGADOR = 'mapper-pagador',
  MAPPER_PRODUTO = 'mapper-produto',
  MAPPER_TABELA_PRECO = 'mapper-tabela-preco',
  PANEL_INTERNO = 'panel-interno',
  PANEL_LOADER = 'panel-loader',
  PANEL_MIGRACAO_CONTRATO = 'panel-migracao-contrato',
  TEXT_NOVO_CONTRATO = 'text-novo-contrato',
  TEXT_PAGADOR = 'text-pagador',
  TEXT_PRODUTO = 'text-produto',
  TEXT_TABELA_PRECO = 'text-tabela-preco',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { MigracaoContratoAliases };
